/**
 * Smart currency formatter for Indian Rupees
 * Shows decimals only when needed
 * 
 * Examples:
 * - 22420 → ₹22,420
 * - 22420.50 → ₹22,420.50
 * - 22420.00 → ₹22,420
 */
export function formatCurrency(amount, options = {}) {
  const {
    showSymbol = true,
    alwaysShowDecimals = false,
  } = options;

  const num = Number(amount) || 0;
  
  // Check if number has decimals
  const hasDecimals = num % 1 !== 0;
  
  // Format with appropriate decimal places
  const formatted = new Intl.NumberFormat("en-IN", {
    style: showSymbol ? "currency" : "decimal",
    currency: "INR",
    minimumFractionDigits: alwaysShowDecimals || hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(num);

  return formatted;
}

/**
 * Format currency without symbol
 */
export function formatAmount(amount) {
  return formatCurrency(amount, { showSymbol: false });
}

/**
 * Format currency with always 2 decimals (for accounting)
 */
export function formatCurrencyAccounting(amount) {
  return formatCurrency(amount, { alwaysShowDecimals: true });
}
